import { TypedUseSelectorHook, useSelector } from 'react-redux'
import { RootState } from '../store'

/**
 * A type compatible {@link useSelector} that has the correct state type
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
